var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"price-condition-card"},[_c('p',[_vm._v("* maandbedrag is gebaseerd op "+_vm._s(_vm.config.duration)+" maanden en "+_vm._s(_vm._f("mileageFormat")(_vm.config.mileage))+" km per jaar, meerprijs per kilometer "+_vm._s(_vm._f("currencyFormat")(_setup.priceKm)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }